module.exports = ".add-portal-link-card .card-header {\n    background-color: #0C9688;\n}\n\n.add-portal-link-card {\n    background-color: #0C9B8E;\n}\n\n.add-portal-link-card .row:nth-child(odd) {\n    background-color: #0C9688;\n}\n\n#drop-area {\n    border: 2px dashed #ccc;\n    border-radius: 20px;\n    /*width: 480px;*/\n}\n#drop-area.highlight {\n    border-color: purple;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/user-management/user-management.modal.component.css
// module id = 914
// module chunks = 4